import type { BoxProps } from '@mui/material/Box';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { UploadIllustration } from 'src/assets/illustrations';

// ----------------------------------------------------------------------

export function UploadPlaceholder({ sx, type = 'file', ...other }: BoxProps & { type?: 'image' | 'video' | 'audio' | 'file' }) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      sx={sx}
      {...other}
    >
      <UploadIllustration type={type} />

      <Stack spacing={1} sx={{ textAlign: 'center' }}>
        <Box sx={{ typography: 'h6' }}>Drop {type} here</Box>
        <Box sx={{ typography: 'body2', color: 'text.secondary' }}>
          Or select for more options
        </Box>
      </Stack>
    </Box>
  );
}
